module.exports = __webpack_public_path__ + "img/agree_fill.3c7c92d6.svg";